import {
  CalendarOutline18Icon,
  WarningFill18Icon,
  WarningOutline18Icon,
} from "@vygruppen/spor-icon-react";
import { CountryCode } from "@vygruppen/vy-train-map";
import {
  EventsOverviewModal,
  productionDeviationTabId,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewModal";
import { useGlobalInformation } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useGlobalInformation";
import { useActiveProductionDeviationIds } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useProductionDeviation";
import { useUpcommingInfrastructureMessages } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useUpcommingInfrastructureMessages";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DropsButton, Flex } from "shared/components/Spor";
import { AlertsCounter } from "shared/components/dataDisplay/AlertsCounter";
import { useLocationHash } from "shared/hooks/useLocationHash";
import { ParseResultProvider } from "shared/utils/useParseResult";
import { useDropsRole } from "stores/useDropsRole";
import { useTheme } from "styled-components";

const UPCOMING_EVENTS_QUERY_KEY = "upcomingInfrastructureEvents";
export const upcomingEventsQueryKey = (countryCode: CountryCode) => [
  UPCOMING_EVENTS_QUERY_KEY,
  countryCode,
];

export const INTERNAL_EVENTS_QUERY_KEY = "internalEvents";

export const PRODUCTION_DEVIATION_LOCATION_HASH = "#produksjonsavvik";

const EventsOverviewButtonAndModalContent = () => {
  const [showModal, setShowModal] = useState(false);
  const { isVaktleder } = useDropsRole();

  const { upcomingInfrastructureEvents } = useUpcommingInfrastructureMessages();

  const { globalEvents } = useGlobalInformation();

  const productionDeviationIds = useActiveProductionDeviationIds();

  const numOfGlobalEvents = globalEvents.isSuccess
    ? globalEvents.data.length
    : 0;
  const numberOfEvents = upcomingInfrastructureEvents.isSuccess
    ? upcomingInfrastructureEvents.data.length + numOfGlobalEvents
    : 0;

  const isActiveGlobalEvents =
    globalEvents.isSuccess && globalEvents.data.length > 0;

  const theme = useTheme();
  const { t } = useTranslation();

  const semantics =
    isActiveGlobalEvents && isVaktleder() ? "warning" : "neutral";

  const Warning18Icon =
    semantics === "neutral" ? WarningOutline18Icon : WarningFill18Icon;

  const selectedTabs =
    isVaktleder() && (globalEvents?.data?.length ?? 0) > 0
      ? "globalEvents"
      : "upcomingEvents";

  const [selectedTabIds, setSelectedTabIds] = useState([selectedTabs]);

  useLocationHash(PRODUCTION_DEVIATION_LOCATION_HASH, () => {
    setSelectedTabIds([productionDeviationTabId]);
    setShowModal(true);
  });
  return (
    <>
      <DropsButton
        semantics={semantics}
        variant="tertiary"
        size="md"
        leftIcon={isVaktleder() ? <Warning18Icon /> : <CalendarOutline18Icon />}
        aria-label="Se fremtidige hendelser"
        onClick={() => setShowModal(true)}
        style={{ width: "fit-content" }}
        pointerEvents="auto"
      >
        {isVaktleder() ? (
          <Flex
            gap="6px"
            alignItems="center"
            color={
              semantics === "neutral"
                ? theme.colorNeutralTextMain
                : theme.colorWarningTextSecondary
            }
          >
            {t("Oversikt hendelser")}
            <AlertsCounter
              alerts={numberOfEvents}
              semantics={semantics === "neutral" ? "transparent" : semantics}
            />
          </Flex>
        ) : (
          t("Fremtidige hendelser")
        )}
      </DropsButton>

      {showModal && (
        <EventsOverviewModal
          selectedTabIds={selectedTabIds}
          setSelectedTabIds={setSelectedTabIds}
          onClose={() => setShowModal(false)}
          upcomingInfrastructureEvents={upcomingInfrastructureEvents}
          globalEvents={globalEvents}
          productionDeviations={productionDeviationIds}
        />
      )}
    </>
  );
};

export const EventsOverviewButtonAndModal = () => (
  <ParseResultProvider>
    <EventsOverviewButtonAndModalContent />
  </ParseResultProvider>
);
